import type { TenantConfig } from '@dmp/api';
import { CACHE_KEYS, SESSION_STORAGE_KEYS } from '@dmp/constant';
import type { LoginMethod } from '@dmp/types';

export const getCachedTenantConfig = () => {
  const value = sessionStorage.getItem(SESSION_STORAGE_KEYS.TENANT_CONFIG);

  if (!value) return null;
  return JSON.parse(value) as { refreshTime: string; config: TenantConfig };
};

export const cacheTenantConfig = (config: TenantConfig) => {
  sessionStorage.setItem(
    SESSION_STORAGE_KEYS.TENANT_CONFIG,
    JSON.stringify({
      refreshTime: new Date().toISOString(),
      config,
    })
  );
};

export const cacheLoginMethod = (loginMethod: LoginMethod) => {
  localStorage.setItem(CACHE_KEYS.LOGIN_METHOD, loginMethod);
};

export const getCachedLoginMethod = () => {
  return localStorage.getItem(CACHE_KEYS.LOGIN_METHOD) as LoginMethod | null;
};
